import { render } from "./RolesExplainer.vue?vue&type=template&id=637c74ea"
import script from "./RolesExplainer.vue?vue&type=script&lang=js"
export * from "./RolesExplainer.vue?vue&type=script&lang=js"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__